<template>
  <div>
    <div class="bar_wrapper" ref="bar_wrapper">
      <div
        ref="bar"
        class="bar"
        :style="{
          backgroundColor: bgColor,
        }"
      >
        <div class="box" ref="swiperbox">
          <div class="swiper">
            <div class="swiper-wrapper" :style="`color: ${buttonColor};`">
              <div
                class="swiper-slide"
                v-for="(item, index) in tabList"
                :class="{ on: tagIndex == index }"
                :style="{ backgroundColor: tagIndex == index ? buttonColor : '#FFF' }"
                :key="index"
                @click="jumpToBlock(index, item)"
              >
              <span>
                {{ item.title }}
              </span>
                <em :style="`border-top-color: ${buttonColor};`"></em>
                <!-- 小红点显示逻辑,0417本期不做，先放着 -->
                <!-- <span class="red-dot"></span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapState } from "vuex";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
  name: "TabBar",
  props: {
    pageConfig: {
      type: Object,
      default: () => {},
    },
    componentConfig: {
      type: Object,
      default: () => {},
    },
    buttonColor: {
      type: String,
      default: "",
    },
    tabList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      swiper: null,
      goodJobZone: [],
      tagGoodJobZone: [],
      requestCount: 0,
      bgColor: "",
      paddingTop: 0,
      stateHeight: 0,
      tagIndex: 0,
      rectsTop: [],
      isScroll: false,
      isMore: false,
      isFirstInit: false,
    };
  },
  computed: {
    ...mapState(["commonStore"]),
    barTop() {
      return 44 + this.stateHeight - 1;
    },
    barHeight() {
      return 54 + this.barTop;
    },
  },
  watch: {
    "commonStore.currentAreaCode": {
      handler(val) {
        this.slideReset();
      },
      immediate: false,
    },
  },
  async mounted() {
    if (this.$store.state.commonStore.searchPage) {
      this.stateHeight = "0px";
    } else {
      this.stateHeight = await this.$base.getAppStateHeight();
    }
    this.stateHeight = parseInt(this.stateHeight);

    this.slideIni();

    // window.addEventListener("scroll", this.handleScroll);
  },
  // beforeDestroy() {
  //   try {
  //     window.removeEventListener("scroll", this.handleScroll);
  //   } catch (e) {}
  // },
  methods: {
    findMatchingData(arrayOne, arrayTwo) {
      const idToObjectMap = {};
      arrayOne.forEach((item) => {
        idToObjectMap[item.id] = item;
      });

      // 遍历数组二，根据映射查找匹配的数据
      const result = [];
      arrayTwo.forEach((id) => {
        if (idToObjectMap[id]) {
          result.push(idToObjectMap[id]);
        }
      });

      return result;
    },
    slideIni() {
      this.swiper = new Swiper(".swiper", {
        slidesPerView: "auto",
        freeMode: true,
        spaceBetween: 6,
      });
    },
    slideReset() {
      this.requestCount = 0;
      this.tagIndex = 0;
      this.swiper.destroy();
      this.tagGoodJobZone = [...this.goodJobZone];
      this.$nextTick(() => {
        this.slideIni();
      });
    },
    handleScroll() {
      const bar_wrapper = this.$refs.bar_wrapper;
      const bar = this.$refs.bar;
      const rect = bar_wrapper.getBoundingClientRect();
      const top = rect.top;

      if (top <= this.barTop) {
        this.bgColor = this.pageConfig.hideColor;
        this.moreTagBg = this.pageConfig.hideColor;
        bar.style.position = "fixed";
        bar.style.top = this.barTop + "px";
        bar.style.zIndex = 10;
      } else {
        this.bgColor = "";
        this.moreTagBg = this.pageConfig.backgroundColor;
        bar.style.position = "relative";
        bar.style.top = "0";
        bar.style.zIndex = 0;
      }

      if (!this.isScroll) {
        let tagIndex = -1;
        const scrollTop =
          document?.documentElement.scrollTop || document.body.scrollTop;
        this.rectsTop.map((item, index) => {
          const top = item - this.barHeight;
          if (scrollTop >= top) {
            tagIndex = index;
          }
        });

        if (tagIndex != -1) {
          this.tagIndex = tagIndex;

          this.adjustSwiperIndex();
        }
      }
    },
    adjustSwiperIndex() {
      // 矫正swiper，确保tag可见
      const box = this.$refs.swiperbox;
      const slide = box.querySelectorAll(".swiper-slide")[this.tagIndex];
      // 解决dom不存在时报错
      if (slide && slide.getBoundingClientRect()) {
        const left =
          slide.getBoundingClientRect().left - box.getBoundingClientRect().left;
        if (left >= box.offsetWidth / 2 || left <= box.offsetWidth / 4) {
          const index = this.tagIndex > 1 ? this.tagIndex - 2 : 0;

          this.swiper.slideTo(index, 200, false);
        }
      }
    },
    scrollWait() {
      // 对scrollTo方法的“回调”处理
      if ("onscrollend" in window) {
        const wait = () => {
          window.removeEventListener("scrollend", wait);
          this.isScroll = false;
        };

        window.addEventListener("scrollend", wait);
      } else {
        setTimeout(() => {
          this.isScroll = false;
        }, 500);
      }
    },
    jumpToBlock(index,cui) {
      // 点击tag后跳转
      this.tagIndex = index;
      this.$emit('handleTabChange',cui)
      const id = this.tagGoodJobZone[index]?.id;
      index = this.goodJobZone.findIndex((item) => item?.id === id);
      this.isScroll = true;
      this.isMore = false;

      // window.scrollTo({
      //   top: this.rectsTop[index] - this.barHeight + 1,
      //   behavior: "smooth",
      // });

      this.adjustSwiperIndex();
      this.scrollWait();
    },
    getTagIndex(index) {
      const id = this.goodJobZone[index].id;
      return this.tagGoodJobZone.findIndex((item) => item.id === id);
    },
    async updateGoodList(data) {
      this.updateComLocation();

      if (data.count) {
        this.requestCount++;
      } else {
        const index = this.getTagIndex(data.index);

        this.tagGoodJobZone.splice(index, 1);
        this.swiper.updateSlides();
      }
    },
    updateComLocation() {
      // 更新专区距离页面顶部top值（专区点击更多后导致变化）
      const comArr = this.$refs.comRefs;
      const scrollTop =
        document?.documentElement.scrollTop || document.body.scrollTop;
      if (comArr) {
        const rectsTop = comArr.map((item) => {
          const top = item.getBoundingClientRect().top;

          return top + scrollTop;
        });

        this.rectsTop = rectsTop;
      }
    },
  },
};
</script>
  
  <style scoped lang="less">
.bar_wrapper {
  // height: 50px;
}

.bar {
  position: relative;
  width: 100%;
  // height: 50px;
  padding: 6px 0 4px 0;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  .box {
    position: relative;
    height: 33px;
    overflow: hidden;
    z-index: 1;
  }

  .more {
    display: none;
    position: absolute;
    width: 25px;
    height: 40px;
    right: 0;
    top: 8px;
    z-index: 2;

    svg {
      position: relative;
      top: 6px;
    }

    span {
      position: absolute;
      width: 23px;
      height: 40px;
      top: 0;
      left: -20px;
    }
  }

  .list {
    display: none;
    position: absolute;
    width: 100%;
    font-weight: bold;
    font-size: 14px;
    color: #222;
    top: 0;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    z-index: 1000;

    &.show {
      display: block;
    }

    .in {
      background-color: #fff;
      border-radius: 0 0 20px 20px;
    }

    .title {
      line-height: 17px;
      padding: 12px 16px 16px;
    }

    ul {
      padding: 0 10px 4px;

      li {
        float: left;
        width: 33%;
        padding: 0 6px 12px;
        box-sizing: border-box;

        span {
          display: block;
          line-height: 42px;
          text-align: center;
          cursor: pointer;
          background: #f2f4f7;
          border-radius: 21px;

          &.on {
            color: #fff;
            background: linear-gradient(180deg, #ffb245 1%, #ff4e0e 99%);
          }
        }
      }

      li:nth-of-type(3n-1) {
        width: 34%;
      }

      &:after {
        display: block;
        content: "";
        clear: both;
      }
    }
  }

  &.has_more {
    .box {
      padding-right: 50px;
    }

    .more {
      display: flex;
    }
  }
}

.pc .bar {
  width: 100%;
}

.swiper {
  .swiper-slide {
    display: inline-block;
    position: relative;
    width: auto;
    line-height: 28px;
    height: 28px;
    font-size: 12px;
    text-align: center;
    padding: 0 15px;
    border-radius: 16px;
    background-color: #fff;
    font-family: PingFang SC;
    min-width: 36px;
    margin-right: 8px !important;
    .adapt_pc_widescreen & {
      font-size: 14px;
    }
    span {
        height: 28px;
        line-height: 28px;
    }

    &:first-child {
      margin-left: 12px;
    }

    &.on {
      position: relative;
      color: #fff;

      em {
        display: block;
        position: absolute;
        content: "";
        left: 53%;
        bottom: -4px;
        width: 0;
        height: 0;
        margin-left: -8px;
        border-style: solid;
        border-width: 6px;
        border-color: transparent;
        border-bottom: none;
      }
    }

    em {
      display: none;
    }
    .red-dot {
      position: absolute;
      right: 0px;
      top: 0;
      width: 8px;
      height: 8px;
      background: linear-gradient(0deg, #FF3838, #FF3838), #FF6439;
      border-radius: 8px;
    }

  }
}
</style>
  